export const checkValidPincode = async (pincode) => {
  try {
    const response = await fetch(
      `/v1/api/lead-gen/validate-pincode/${pincode}`,
      {
        method: "POST",
      }
    );

    const data = await response.json();
    const isValid = data?.result?.data?.isValid;
    return isValid;
  } catch (error) {
    console.error("Error validating pincode:", error);
    return false;
  }
};
